import React from 'react';
import { ListProvider } from './ListContext';
import { VirtualList } from './VirtualList';
import { QwantaComponent } from 'qwanyx';

export function InfiniteList({
  query = {},
  header,
  card, // Card is your JSON definition
  sort = {},
  projection = {},
  width = "100%",
  height = "100%",
  className = "",
  style = {},
  batchSize = 20,
  threshold = 300,
  loadAllAtOnce = true // Add this parameter with default to true
}) {
  const containerStyle = {
    width,
    height,
    overflowY: 'auto',
    ...style
  };

  // Render function that uses QwantaComponent to render the item
  const renderItem = (item, index) => {
    // Get the cardDef - if it's an array with one item, use that item
    const cardDef = Array.isArray(card) && card.length === 1 ? card[0] : card;
    
    if (!cardDef || !cardDef.type) {
      console.error('Invalid card definition:', card);
      return <div>Invalid card definition</div>;
    }
    
    // Clone the card definition
    const processedCard = JSON.parse(JSON.stringify(cardDef));
    
    // Process the template strings
    processTemplateStrings(processedCard, item);
    
    return (
      <QwantaComponent
        component={processedCard}
        index={index}
        parentId="infinite-card"
      />
    );
  };
  
  // Process template strings recursively
  function processTemplateStrings(obj, item) {
    if (!obj || typeof obj !== 'object') return;
    
    for (const key in obj) {
      if (typeof obj[key] === 'string') {
        // Replace template strings like ${item.name} with actual values
        obj[key] = obj[key].replace(/\${item\.([^}]+)}/g, (match, prop) => {
          return item[prop] !== undefined ? item[prop] : '';
        });
      } else if (typeof obj[key] === 'object' && obj[key] !== null) {
        // Recursively process nested objects
        processTemplateStrings(obj[key], item);
      }
    }
  }

  return (
    <ListProvider
      query={query}
      sort={sort}
      projection={projection}
      batchSize={batchSize}
      autoLoadThreshold={threshold}
      loadAllAtOnce={loadAllAtOnce} // Pass this new prop to ListProvider
    >
      <div className={className} style={containerStyle}>
        <VirtualList renderItem={renderItem} />
      </div>
    </ListProvider>
  );
}

export default InfiniteList;